import ArticleSixPage from './containers/ArticleSixContainer'

export default store => {
  return {
    path: '6',
    exact: true,
    getComponent(nextState, cb) {
      require.ensure([], () => {
        cb(null, ArticleSixPage, 'articles')
      })
    },
  }
}
